var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBacktotop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "website-eng",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mainpage1",
    transform: "translate(-1739.000000, -1842.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blocks-/-Commun-/-Form-navigation-/-Scroll-up-button",
    transform: "translate(1739.000000, 1842.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Containers--/-8-Padd-/-10-Radius"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shadow",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background-colour",
    fill: "#003DA5",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Border",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Padding-guide",
    x: 8,
    y: 8,
    width: 28,
    height: 28
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Arrow-up",
    transform: "translate(10.000000, 10.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,5 L12.9998932,14.585 L17.2928932,10.2928932 L18.7071068,11.7071068 L12,18.4142136 L5.29289322,11.7071068 L6.70710678,10.2928932 L10.9998932,14.585 L11,5 L13,5 Z",
    id: "Icon-colour",
    transform: "translate(12.000000, 11.707107) scale(1, -1) translate(-12.000000, -11.707107) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacktotop);
export default __webpack_public_path__ + "static/media/backtotop.22567e892ede20bb40aaa3999cce5f39.svg";
export { ForwardRef as ReactComponent };